<template>
	<div class="button-preview" :class="{ 'stan-device preview-type-store new': showDevice }">
		<div class="site-preview-section">
			<div class="store-theme mx-auto site__prev__masking place-content-center" :class="storeTheme" style="max-width: 405px;">
				<div class="store-content">
					<template v-if="type == 'lead-magnet'">
						<LeadMagnetButton
							:user="user"
							:title="product.title"
							:button_text="config.button_text || config.title"
							:heading="config.heading"
							:image="config.image"
							:tagline="config.tagline"
							:questions="config.questions"
							:disabled="true"
							ref="form"
						/>
					</template>
					<template v-else-if="config.layout.toLowerCase() === 'preview'">
						<SitePreviewButton
							:user="user"
							:title="product.title"
							:button_text="config.button_text"
							:heading="config.heading"
							:image="config.image"
							:tagline="config.tagline"
							:price="product.price"
							:product="product"
							:currency="user.data.currency"
							:reviews="product.reviews"
							:productType="product.type"
							:quantity="productQuantity(product)"
							ref="form"
							@imageEdit="handleImageEdit"
							@taglineUpdate="handleTaglineUpdated"
							@buttonUpdate="handleButtonUpdated"
							@titleUpdate="handleTitleUpdated"
							:editable="editable"
							:animate="animate"
							@editorOpened="handleEditorOpened"
						/>
					</template>
					<template v-else-if="config.layout.toLowerCase() === 'callout'">
						<SiteCalloutButton
							:user="user"
							:title="product.title"
							:button_text="config.button_text"
							:heading="config.heading"
							:image="config.image"
							:tagline="config.tagline"
							:price="product.price"
							:reviews="product.reviews"
							:productType="product.type"
							:currency="user.data.currency"
							:quantity="productQuantity(product)"
							ref="form"
							@imageEdit="handleImageEdit"
							@taglineUpdate="handleTaglineUpdated"
							@buttonUpdate="handleButtonUpdated"
							@titleUpdate="handleTitleUpdated"
							:editable="editable"
							:animate="animate"
							@editorOpened="handleEditorOpened"
						/>
					</template>
					<template v-else-if="config.layout.toLowerCase() === 'button'">
						<SiteButton
							:user="user"
							:title="product.title"
							:image="config.image"
							:price="product.price"
							:reviews="product.reviews"
							:productType="product.type"
							:currency="user.data.currency"
							:quantity="productQuantity(product)"
							ref="form"
							@imageEdit="handleImageEdit"
							@titleUpdate="handleTitleUpdated"
							:editable="editable"
							:animate="animate"
							@editorOpened="handleEditorOpened"
						/>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import LeadMagnetButton from '~/stan-vue-shared/components/buttons/LeadMagnetButton'
	import SitePreviewButton from '~/stan-vue-shared/components/buttons/SitePreviewButton'
	import SiteCalloutButton from '~/stan-vue-shared/components/buttons/SiteCalloutButton'
	import SiteButton from '~/stan-vue-shared/components/buttons/SiteButton'

	export default {
		components: {
			LeadMagnetButton,
			SitePreviewButton,
			SiteCalloutButton,
			SiteButton,
		},
		props: {
			config: { type: Object },
			user: { type: Object },
			type: { type: String },
			showCallout: { type: Boolean, default: true },
			product: { type: Object, default: () => {} },
			showDevice: { type: Boolean, default: false },
			editable: { type: Boolean, default: false },
			animate: { type: Boolean, default: false },
			removePadding: { type: Boolean, default: false },
		},
		data() {
			return {}
		},
		computed: {
			...mapGetters('Stores', ['getStoreTheme']),
			storeTheme() {
				return `${this.getStoreTheme} ${this.removePadding ? 'p-0' : 'mb-3'}` || 'default'
			},
		},
		methods: {
			toggleLayout() {
				if (this.config.layout === 'Callout') {
					this.config.layout = 'Button'
				} else if (this.config.layout === 'Button') {
					this.config.layout = 'Callout'
				}
				this.$emit('updated')
			},
			productQuantity(product) {
				return product?.inventory?.manage ? product.inventory.stock : undefined
			},
			handleTitleUpdated(text) {
				this.$emit('titleUpdate', text)
			},
			handleImageEdit() {
				this.$emit('imageEdit')
			},
			handleTaglineUpdated(text) {
				this.$emit('taglineUpdate', text)
			},
			handleButtonUpdated(text) {
				this.$emit('buttonUpdate', text)
			},
			handleEditorOpened() {
				this.$emit('editorOpened')
			},
		},
	}
</script>
<style lang="scss" scoped>
	@import 'src/stan-vue-shared/assets/styles/themes/index.scss';

	.button-preview {
		min-height: 250px;

		.store-theme .store-content {
			padding: 0 !important;
			margin: 0 !important;
			min-height: unset !important;
		}

		.store-theme.spotlight .store-content {
			margin-top: auto !important;
			margin-bottom: auto !important;
			min-height: auto !important;
		}
	}

	.store-theme {
		padding: 15px;
		border-radius: 10px;
	}
</style>
